export const regex = {
  phone: /^\d{10}$/,
  email: /\S+@\S+\.\S+/,
  pincode: /^[1-9][0-9]{5}$/,
  gst: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[ZD][0-9A-Z]{1}$/,
  pan: /[A-Z]{5}[0-9]{4}[A-Z]{1}/,
  aadhaar: /^[2-9][0-9]{3}\s?[0-9]{4}\s?[0-9]{4}$/,
  drivingLicense: /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/,
  vehicleRegistrationNumber:
    /^(([A-Z]){2,3}(?:[0-9]){1,2}(?:[A-Za-z]){1,2}([0-9]){1,4})|(([A-Za-z]){2,3}([0-9]){1,4})$|^([A-Za-z]){2}([0-9]){6}$/,
};
